/**
 * jQuery carousels (Slick/Owl) reparent slide nodes. React still expects them as
 * direct children and throws on unmount — guard removeChild for that case.
 */
export function installDomSafeRemoveChild() {
  if (typeof Node === 'undefined' || Node.prototype.__qtechRemoveChildPatched) {
    return;
  }

  const original = Node.prototype.removeChild;

  Node.prototype.removeChild = function removeChildSafe(child) {
    if (child && child.parentNode !== this) {
      return child;
    }
    return original.call(this, child);
  };

  Node.prototype.__qtechRemoveChildPatched = true;
}
